if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => {
            if (!response.ok) throw new Error('Section fetch failed');
            return response.text();
          })
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const preview = doc.querySelector('pickup-availability-preview');
            const drawer = doc.querySelector('pickup-availability-drawer');
            this.renderPreview({ preview, drawer });
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview({ preview, drawer: drawerEl }) {
        const existingDrawer = document.querySelector('pickup-availability-drawer');
        if (existingDrawer) existingDrawer.remove();
        if (!preview || !drawerEl) {
          this.renderError();
          return;
        }

        this.innerHTML = preview.outerHTML;
        this.setAttribute('available', '');

        document.body.appendChild(drawerEl);
        const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
        colorClassesToApply.forEach((colorClass) => {
          document.querySelector('pickup-availability-drawer').classList.add(colorClass);
        });

        const button = this.querySelector('button');
        if (button) {
          button.addEventListener('click', (evt) => {
            evt.preventDefault();
            const drawer = document.querySelector('pickup-availability-drawer');
            if (drawer && typeof drawer.show === 'function') {
              drawer.show(button);
            }
          });
        }

        // Bind "In Filiale reservieren" buttons in drawer (content is dynamically injected, inline script does not run)
        const rootUrl = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
        drawerEl.querySelectorAll('.pickup-reserve-checkout').forEach((btn) => {
          if (btn._bound) return;
          btn._bound = true;
          btn.addEventListener('click', () => {
            const variantId = btn.getAttribute('data-variant-id');
            if (!variantId) return;
            const root = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';
            fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
            }).then((r) => r.json()).then((data) => {
              if (data.status === 422 || (data.message && String(data.message).indexOf('error') !== -1)) return;
              window.location.href = root + 'checkout';
            }).catch(() => {
              window.location.href = root + 'cart/add?id=' + variantId + '&quantity=1';
            });
          });
        });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('product-modal-open');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        document.body.classList.add('product-modal-open');
        trapFocus(this);
      }
    }
  );
}
